import { render, staticRenderFns } from "./shippingSelect.vue?vue&type=template&id=1f365805"
import script from "./shippingSelect.vue?vue&type=script&lang=js"
export * from "./shippingSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports